import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";
import React from "react";
import { PaymentMethodCard } from "@nykaa/payment-ui/src/PaymentMethodCard/mobile";


const UpiFailureWrapper = ({ intentConfig, toggleNewPaymentAccordian, endIcon, theme }: any) => {
  if (intentConfig?.title) {
    return (
      <PaymentMethodCard
        title={intentConfig?.title}
        titleColor={getHexToRgba(theme?.colors?.pebble900, 0.92)}
        titleFont={theme.typography.subTitleLarge}
        isContentVisible={true}
        leadingIcon={intentConfig?.iconIntentUrl || intentConfig?.icon}
        endIcon={endIcon}
        noBorder={true}
        noMargin={true}
        isDisabled={false}
        isHidden={false}
        noSidePadding={false}
        toggleAccordian={toggleNewPaymentAccordian}
        theme={theme}
        dataTestId={"payment_failure_intent"}
      />
    );
  }
  return null;
};

export default UpiFailureWrapper;
